angular.module('common.directives.searchTermHighlight', [])

    .directive('searchTermHighlight', function ($timeout) {
    return {
        restrict: 'A',
        scope: { searchTermHighlight: '=' },
        link: function (scope, element, attrs) {

            var doHighlight = _.debounce(function (e) {
                $(element).unhighlight();

                if (!String.isNullOrWhiteSpace(e)) {
                    $(element).highlight(e);
                } else {
                    //$(element).unhighlight();
                }
            }, 300);

            var searchTermWatcher = scope.$watch('searchTermHighlight', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    doHighlight(newValue);
                }
            });

            scope.$on('$destroy', function () {
               if (searchTermWatcher) {
                   searchTermWatcher();
               }
            });
        }
    };
})
